import { supabase } from '@/shared/lib/supabase';
import { logger } from '@/shared/lib/logger';
import { homeSummarySchema, type HomeSummary } from '@shared/schemas/home';

export const homeKeys = {
  all: ['home'] as const,
  summary: (target: string, limit: number) => [...homeKeys.all, 'summary', target, limit] as const,
};

/**
 * Home dashboard cross-group (spec §7.1).
 *
 * Devuelve saldo global, resumen por grupo y feed de actividad reciente,
 * todo convertido a la moneda del usuario.
 */
export async function fetchHomeSummary(
  targetCurrency: string,
  activityLimit = 15
): Promise<HomeSummary> {
  const { data, error } = await supabase.rpc('my_home_summary', {
    p_target_currency: targetCurrency,
    p_activity_limit: activityLimit,
  });
  if (error) {
    logger.error('fetchHomeSummary failed', { code: error.code, message: error.message });
    throw new Error(error.message);
  }
  return homeSummarySchema.parse(data);
}
